<template>
  <div class="calico-ai-content-page">
    <div class="ai-content">
      <CalicoAIContent content="Commodo tristique scelerisque dignissim sed eu viverra imperdiet dui. Nunc nisl ultrices tristique mattis sit quis at quis odio. Augue diam neque eget consectetur in faucibus sit amet quis. Odio in volutpat nisl et aliquam. Sit scelerisque sodales vitae lorem. Convallis lacus eu facilisi eu curabitur a quis vel. Ultricies euismod viverra consequat cursus pellentesque neque nunc in. Elit feugiat nisl nulla lectus aliquam orci blandit ac. Pharetra nunc eu vivamus neque id lectus orci ut. Risus mi et leo aliquet diam. Ornare donec id purus dictumst. Auctor sit ut a sodales eget." />
    </div>
  </div>
</template>
  
  <script>
  import CalicoAIContent from '@/components/calico/aiContent/index.vue';
  
  export default {
    name: 'CalicoAIContentPage',
    components: {
      CalicoAIContent,
    }
  };
  </script>
  
  <style lang="scss">
  .calico-ai-content-page {
    @include stack-space($space-medium);
    justify-content: center;
    align-items: center;
    width: 100%;
    .ai-content {
      width: 50%;
    }
  }
  </style>
  